import { LogReport, setSpmPrefix, getBuvid } from '@bilibili-intl/log-report';
import type { Report, PvData, ClickData, ExposeData, CustomData, CustomOptions } from '@bilibili-intl/log-report';
import { getEnv } from './env';

const env = getEnv();
console.log('[env]:', env);

// web直播间页面spmid
const SPM_PREFIX = '444.136';

// 控制生成时序 在初始化LogReport前手动调用一次 写入 cookie
export const buvid = getBuvid();
export class LogReporter {
  static instance: Report | null = null;
  static spmId = '';

  static setSpmId(spmId: string) {
    setSpmPrefix(spmId);
    this.spmId = spmId;
  }

  static getSpmId(): string {
    return this.spmId;
  }

  static getFromSpmId(): string | null {
    if (!import.meta.env.SSR) {
      return new URL(location.href).searchParams.get('fromSpmId');
    }
    return null;
  }

  static init(spmId = SPM_PREFIX) {
    // 在 Node 中初始化会 throw error，只在 CSR 时使用
    if (import.meta.env.SSR) {
      return;
    }
    if (this.instance === null) {
      this.instance = LogReport({
        logId: {
          pv: '000014',
          click: '000017',
          expose: '018050',
        },
        watcher: {
          expose: {
            enable: true
          }
        },
        // autoSendPv: true,
        // disable: ['dev', 'uat'].includes(env),
      });
    }
    return this.instance;
  }

  static sendPV(data?: PvData) {
    return this.instance?.sendPv(data);
  }

  static sendClick(data: ClickData) {
    return this.instance?.sendClick(data);
  }

  static sendExpose(data: ExposeData) {
    return this.instance?.sendExpose(data);
  }

  static sendCustom(data: CustomData<{}>, options: CustomOptions<{}>) {
    this.instance?.sendCustom(data, options);
  }
}